import { createAsyncThunk } from "@reduxjs/toolkit";
import { getActiveVEBPlans } from "../../utils/api/pages/VEBPlaniInit";
import { VEBPlanSchema } from "../../types/VEBPlanSchema";

export const fetchActiveVEBPlans = createAsyncThunk(
	"vebPlans/fetchActiveVEBPlans",
	async (
		group_number: number | string
	): Promise<{
		currentPlans: VEBPlanSchema[];
		futurePlans: VEBPlanSchema[];
	}> => {
		return await getActiveVEBPlans(group_number);
	}
);
